import { FilterableQueryParams } from 'models/FilterableQueryParams';
import { allQueryParamsFalsy } from './allQueryParamsFalsy';

export function getRobotsDefinition(
  queryParams: FilterableQueryParams,
  totalShopCount: number
): string {
  function isIndexable() {
    if (queryParams.account) {
      return !queryParams.category && totalShopCount > 0;
    }

    return !queryParams.keyword || totalShopCount > 0;
  }

  return [
    allQueryParamsFalsy(queryParams) && isIndexable() ? 'index' : 'noindex',
    'follow'
  ].join(',');
}
